import { useCallback, useState } from 'react';
import back4app2 from '../../back4app2';

/**
 * Runs one statement against the app's database and keeps what the drawer
 * forms need to say about it: whether it is running, and Postgres's refusal
 * if there was one. A refusal is an ordinary outcome — the form stays open
 * with what was typed, and the message is printed under it.
 */
export function useStatement(appId: string) {
  const [isRunning, setIsRunning] = useState(false);
  const [failure, setFailure] = useState<string | undefined>();

  const run = useCallback((sql: string, onSuccess: () => void) => {
    setIsRunning(true);
    setFailure(undefined);

    back4app2
      .runAppDatabaseStatement(appId, sql)
      .then(outcome => {
        if (outcome.errorMessage) {
          setFailure(outcome.errorMessage);
          return;
        }
        onSuccess();
      })
      .catch((e: Error) => setFailure(e.message))
      .finally(() => setIsRunning(false));
  }, [appId]);

  const reset = useCallback(() => setFailure(undefined), []);

  return { run, isRunning, failure, reset };
}
